import { render } from "./ModalAllTask.vue?vue&type=template&id=5502a44a"
import script from "./ModalAllTask.vue?vue&type=script&lang=js"
export * from "./ModalAllTask.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__